import * as C from '../shared/constants';
export * from '../shared/constants';
export const BASE_PATH = '/match';
export const IMG_JOBSITES = `${C.IMG_HOST}/fe/match/jobsites.png`;
export const STORAGE_KEY = '-match-globalStore';
export const DEBOUNCE_SAVE_TIMEOUT = 2000;

// green, blue, orange
export const CIRCLE_COLORS = [
  '#FF7F17',
  '#FF7F17',
  '#FF7F17',
  '#FF7F17',
  '#FF7F17',
  '#FF7F17',
  '#0090F9',
  '#0090F9',
  '#45C57C',
  '#45C57C'
];

// 275 most populated cities
export const CITIES = [
  'New York, New York',
  'Los Angeles, California',
  'Chicago, Illinois',
  'Houston, Texas',
  'Philadelphia, Pennsylvania',
  'Phoenix, Arizona',
  'San Antonio, Texas',
  'San Diego, California',
  'Dallas, Texas',
  'San Jose, California',
  'Jacksonville, Florida',
  'Indianapolis, Indiana',
  'San Francisco, California',
  'Austin, Texas',
  'Columbus, Ohio',
  'Fort Worth, Texas',
  'Charlotte, North Carolina',
  'Detroit, Michigan',
  'El Paso, Texas',
  'Memphis, Tennessee',
  'Baltimore, Maryland',
  'Boston, Massachusetts',
  'Seattle, Washington',
  'Washington, District of Columbia',
  'Nashville, Tennessee',
  'Denver, Colorado',
  'Louisville, Kentucky',
  'Milwaukee, Wisconsin',
  'Portland, Oregon',
  'Las Vegas, Nevada',
  'Oklahoma City, Oklahoma',
  'Albuquerque, New Mexico',
  'Tucson, Arizona',
  'Fresno, California',
  'Sacramento, California',
  'Long Beach, California',
  'Kansas City, Missouri',
  'Mesa, Arizona',
  'Virginia Beach, Virginia',
  'Atlanta, Georgia',
  'Colorado Springs, Colorado',
  'Omaha, Nebraska',
  'Raleigh, North Carolina',
  'Miami, Florida',
  'Cleveland, Ohio',
  'Tulsa, Oklahoma',
  'Oakland, California',
  'Minneapolis, Minnesota',
  'Wichita, Kansas',
  'Arlington, Texas',
  'Bakersfield, California',
  'New Orleans, Louisiana',
  'Honolulu, Hawaii',
  'Anaheim, California',
  'Tampa, Florida',
  'Aurora, Colorado',
  'Santa Ana, California',
  'Saint Louis, Missouri',
  'Pittsburgh, Pennsylvania',
  'Corpus Christi, Texas',
  'Riverside, California',
  'Cincinnati, Ohio',
  'Lexington, Kentucky',
  'Anchorage, Alaska',
  'Stockton, California',
  'Toledo, Ohio',
  'Saint Paul, Minnesota',
  'Newark, New Jersey',
  'Greensboro, North Carolina',
  'Buffalo, New York',
  'Plano, Texas',
  'Lincoln, Nebraska',
  'Henderson, Nevada',
  'Fort Wayne, Indiana',
  'Jersey City, New Jersey',
  'Saint Petersburg, Florida',
  'Chula Vista, California',
  'Norfolk, Virginia',
  'Orlando, Florida',
  'Chandler, Arizona',
  'Laredo, Texas',
  'Madison, Wisconsin',
  'Winston-Salem, North Carolina',
  'Lubbock, Texas',
  'Baton Rouge, Louisiana',
  'Durham, North Carolina',
  'Garland, Texas',
  'Glendale, Arizona',
  'Reno, Nevada',
  'Hialeah, Florida',
  'Chesapeake, Virginia',
  'Scottsdale, Arizona',
  'North Las Vegas, Nevada',
  'Irving, Texas',
  'Fremont, California',
  'Irvine, California',
  'Birmingham, Alabama',
  'Rochester, New York',
  'San Bernardino, California',
  'Spokane, Washington',
  'Gilbert, Arizona',
  'Arlington, Virginia',
  'Montgomery, Alabama',
  'Boise, Idaho',
  'Richmond, Virginia',
  'Des Moines, Iowa',
  'Modesto, California',
  'Fayetteville, North Carolina',
  'Shreveport, Louisiana',
  'Akron, Ohio',
  'Tacoma, Washington',
  'Aurora, Illinois',
  'Oxnard, California',
  'Fontana, California',
  'Yonkers, New York',
  'Augusta, Georgia',
  'Mobile, Alabama',
  'Little Rock, Arkansas',
  'Moreno Valley, California',
  'Glendale, California',
  'Amarillo, Texas',
  'Huntington Beach, California',
  'Columbus, Georgia',
  'Grand Rapids, Michigan',
  'Salt Lake City, Utah',
  'Tallahassee, Florida',
  'Worcester, Massachusetts',
  'Newport News, Virginia',
  'Huntsville, Alabama',
  'Knoxville, Tennessee',
  'Providence, Rhode Island',
  'Santa Clarita, California',
  'Grand Prairie, Texas',
  'Brownsville, Texas',
  'Jackson, Mississippi',
  'Overland Park, Kansas',
  'Garden Grove, California',
  'Santa Rosa, California',
  'Chattanooga, Tennessee',
  'Oceanside, California',
  'Fort Lauderdale, Florida',
  'Rancho Cucamonga, California',
  'Port Saint Lucie, Florida',
  'Ontario, California',
  'Vancouver, Washington',
  'Tempe, Arizona',
  'Springfield, Missouri',
  'Lancaster, California',
  'Eugene, Oregon',
  'Pembroke Pines, Florida',
  'Salem, Oregon',
  'Cape Coral, Florida',
  'Peoria, Arizona',
  'Sioux Falls, South Dakota',
  'Springfield, Massachusetts',
  'Elk Grove, California',
  'Rockford, Illinois',
  'Palmdale, California',
  'Corona, California',
  'Salinas, California',
  'Pomona, California',
  'Pasadena, Texas',
  'Joliet, Illinois',
  'Paterson, New Jersey',
  'Kansas City, Kansas',
  'Torrance, California',
  'Syracuse, New York',
  'Bridgeport, Connecticut',
  'Hayward, California',
  'Fort Collins, Colorado',
  'Escondido, California',
  'Lakewood, Colorado',
  'Naperville, Illinois',
  'Dayton, Ohio',
  'Hollywood, Florida',
  'Sunnyvale, California',
  'Alexandria, Virginia',
  'Mesquite, Texas',
  'Hampton, Virginia',
  'Pasadena, California',
  'Orange, California',
  'Savannah, Georgia',
  'Cary, North Carolina',
  'Fullerton, California',
  'Warren, Michigan',
  'Clarksville, Tennessee',
  'McKinney, Texas',
  'McAllen, Texas',
  'New Haven, Connecticut',
  'Sterling Heights, Michigan',
  'West Valley City, Utah',
  'Columbia, South Carolina',
  'Killeen, Texas',
  'Topeka, Kansas',
  'Thousand Oaks, California',
  'Cedar Rapids, Iowa',
  'Olathe, Kansas',
  'Elizabeth, New Jersey',
  'Waco, Texas',
  'Hartford, Connecticut',
  'Visalia, California',
  'Gainesville, Florida',
  'Simi Valley, California',
  'Stamford, Connecticut',
  'Bellevue, Washington',
  'Concord, California',
  'Miramar, Florida',
  'Coral Springs, Florida',
  'Lafayette, Louisiana',
  'Charleston, South Carolina',
  'Carrollton, Texas',
  'Roseville, California',
  'Thornton, Colorado',
  'Beaumont, Texas',
  'Allentown, Pennsylvania',
  'Surprise, Arizona',
  'Evansville, Indiana',
  'Abilene, Texas',
  'Frisco, Texas',
  'Independence, Missouri',
  'Santa Clara, California',
  'Springfield, Illinois',
  'Vallejo, California',
  'Victorville, California',
  'Athens, Georgia',
  'Peoria, Illinois',
  'Lansing, Michigan',
  'Ann Arbor, Michigan',
  'El Monte, California',
  'Denton, Texas',
  'Berkeley, California',
  'Provo, Utah',
  'Downey, California',
  'Midland, Texas',
  'Norman, Oklahoma',
  'Waterbury, Connecticut',
  'Costa Mesa, California',
  'Inglewood, California',
  'Manchester, New Hampshire',
  'Murfreesboro, Tennessee',
  'Columbia, Missouri',
  'Elgin, Illinois',
  'Clearwater, Florida',
  'Miami Gardens, Florida',
  'Rochester, Minnesota',
  'Pueblo, Colorado',
  'Lowell, Massachusetts',
  'Wilmington, North Carolina',
  'San Buenaventura (Ventura), California',
  'Arvada, Colorado',
  'Westminster, Colorado',
  'West Covina, California',
  'Gresham, Oregon',
  'Norwalk, California',
  'Fargo, North Dakota',
  'Carlsbad, California',
  'Fairfield, California',
  'Cambridge, Massachusetts',
  'Wichita Falls, Texas',
  'High Point, North Carolina',
  'Billings, Montana',
  'Green Bay, Wisconsin',
  'West Jordan, Utah',
  'Richmond, California',
  'Murrieta, California',
  'Burbank, California',
  'Palm Bay, Florida',
  'Everett, Washington',
  'Flint, Michigan',
  'Antioch, California',
  'Erie, Pennsylvania',
  'South Bend, Indiana',
  'Daly City, California',
  'Centennial, Colorado',
  'Temecula, California'
];

export const STATES = [
  {code: 'AL', name: 'Alabama'},
  {code: 'AK', name: 'Alaska'},
  {code: 'AZ', name: 'Arizona'},
  {code: 'AR', name: 'Arkansas'},
  {code: 'CA', name: 'California'},
  {code: 'CO', name: 'Colorado'},
  {code: 'CT', name: 'Connecticut'},
  {code: 'DE', name: 'Delaware'},
  {code: 'DC', name: 'District Of Columbia'},
  {code: 'FL', name: 'Florida'},
  {code: 'GA', name: 'Georgia'},
  {code: 'HI', name: 'Hawaii'},
  {code: 'ID', name: 'Idaho'},
  {code: 'IL', name: 'Illinois'},
  {code: 'IN', name: 'Indiana'},
  {code: 'IA', name: 'Iowa'},
  {code: 'KS', name: 'Kansas'},
  {code: 'KY', name: 'Kentucky'},
  {code: 'LA', name: 'Louisiana'},
  {code: 'ME', name: 'Maine'},
  {code: 'MD', name: 'Maryland'},
  {code: 'MA', name: 'Massachusetts'},
  {code: 'MI', name: 'Michigan'},
  {code: 'MN', name: 'Minnesota'},
  {code: 'MS', name: 'Mississippi'},
  {code: 'MO', name: 'Missouri'},
  {code: 'MT', name: 'Montana'},
  {code: 'NE', name: 'Nebraska'},
  {code: 'NV', name: 'Nevada'},
  {code: 'NH', name: 'New Hampshire'},
  {code: 'NJ', name: 'New Jersey'},
  {code: 'NM', name: 'New Mexico'},
  {code: 'NY', name: 'New York'},
  {code: 'NC', name: 'North Carolina'},
  {code: 'ND', name: 'North Dakota'},
  {code: 'OH', name: 'Ohio'},
  {code: 'OK', name: 'Oklahoma'},
  {code: 'OR', name: 'Oregon'},
  {code: 'PA', name: 'Pennsylvania'},
  {code: 'RI', name: 'Rhode Island'},
  {code: 'SC', name: 'South Carolina'},
  {code: 'SD', name: 'South Dakota'},
  {code: 'TN', name: 'Tennessee'},
  {code: 'TX', name: 'Texas'},
  {code: 'UT', name: 'Utah'},
  {code: 'VT', name: 'Vermont'},
  {code: 'VA', name: 'Virginia'},
  {code: 'WA', name: 'Washington'},
  {code: 'WV', name: 'West Virginia'},
  {code: 'WI', name: 'Wisconsin'},
  {code: 'WY', name: 'Wyoming'}
];
